import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-list__item" }

import InfoSvg from '../assets/info.svg';

// Other



export default /*@__PURE__*/_defineComponent({
  __name: 'VInfoItem',
  props: {
    label: { type: String, required: true },
    description: { type: String, default: '' },

    error: { type: Boolean, default: false },
    required: { type: Boolean, default: false },

    gap: { type: Boolean, default: false },
    wrap: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    overflowHidden: { type: Boolean, default: false },
},
  setup(__props) {

// Svg


return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["info-list__item-label", { required: __props.required }])
    }, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      (__props.description)
        ? _withDirectives((_openBlock(), _createBlock(_unref(InfoSvg), {
            key: 0,
            class: "info-list__item-info"
          }, null, 512)), [
            [_directive_tooltip, __props.description]
          ])
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["info-list__item-content", {
                'info-list__item-content--gap': __props.gap,
                'info-list__item-content--wrap': __props.wrap,
                'info-list__item-content--error': __props.error,
                'info-list__item-content--center': __props.center,
                'info-list__item-content--overflow-hidden': __props.overflowHidden,
            }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})